import { useSyncExternalStore } from "react";

/**
 * Visit-only history of calculations: the last 10, kept in this module's memory.
 * Nothing is written to localStorage, sessionStorage, cookies or the server, so closing or reloading the tab erases it.
 */
export const HISTORY_LIMIT = 10;

export interface HistoryEntry { id: number; tool: string; summary: string; at: number }

let entries: HistoryEntry[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Adds a calculation (newest first). The same summary as the newest entry is not repeated. */
export function recordCalculation(tool: string, summary: string, now = Date.now()): void {
  if (entries[0] && entries[0].tool === tool && entries[0].summary === summary) return;
  entries = [{ id: nextId++, tool, summary, at: now }, ...entries].slice(0, HISTORY_LIMIT);
  emit();
}
export function getHistory(tool?: string): HistoryEntry[] { return tool ? entries.filter((e) => e.tool === tool) : entries; }
export function clearHistory(): void { entries = []; emit(); }

const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };
export function useCalcHistory(): HistoryEntry[] { return useSyncExternalStore(subscribe, () => entries, () => entries); }
